// extracted by mini-css-extract-plugin
export var avatar = "_n9-3";
export var avatarContainer = "_n9-2";
export var avatarSpacer = "_n9-5";
export var avatarSpacerContainer = "_n9-4";
export var avatarStackContainer = "_n9-1";
export var bubble = "_n9-0";
export var remainderBubble = "_n9-6";